module.exports = __webpack_public_path__ + "88e25077.svg";